<template>
  <UDashboardPanel id="settings" :ui="{ body: 'h-full w-full sm:p-0 p-0' }">
    <!--
    <template #header>
      <UDashboardNavbar title="Settings">
        <template #leading>
          <UDashboardSidebarCollapse />
        </template>
        <template #right>
          <LanguageSwitcher />
        </template>
      </UDashboardNavbar>
    </template>
    -->
    
    <template #body>
      <div class="flex flex-col gap-4 sm:gap-6 lg:gap-12 w-full lg:max-w-3xl mx-auto">
        <UForm
          id="settings"
          :schema="profileSchema"
          :state="profile"
          @submit="onSubmit"
          class="mt-4"
        >
          <UPageCard
            title="Settings"
            description=""
            variant="naked"
            orientation="horizontal"
            class="mb-4 mt-2"
          >
          </UPageCard>

          <UPageCard variant="subtle">
            <div class="flex gap-4 mb-2">
              <UFormField
                name="name"
                label="Full name"
                required
                class="flex-1"
              >
                <UInput
                  v-model="profile.name"
                  autocomplete="off"
                  size="md"
                  class="w-full"
                  disabled
                />
              </UFormField>

              <UFormField
                name="email"
                label="Email"
                required
                class="flex-1"
              >
                <UInput
                  v-model="profile.email"
                  type="email"
                  autocomplete="off"
                  size="md"
                  class="w-full"
                  disabled
                />
              </UFormField>
            </div>

            <div class="flex justify-end mt-3">
              <UButton
                form="settings"
                label="Save Changes"
                color="primary"
                type="submit"
                size="lg"
                class="min-w-[120px]"
              />
            </div>
          </UPageCard>
        </UForm>
      </div>
    </template>
  </UDashboardPanel>
</template>

<script setup lang="ts">
import { h, resolveComponent, ref, computed, shallowRef } from 'vue'
import { sub } from 'date-fns'
import { useUser } from '@/store';
import z from 'zod'
import type { FormSubmitEvent } from '@nuxt/ui'
import { reactive } from 'vue'

const UButton = resolveComponent('UButton')
const UCheckbox = resolveComponent('UCheckbox')
const UBadge = resolveComponent('UBadge')
const UDropdownMenu = resolveComponent('UDropdownMenu')

const userStore = useUser();

const toast = useToast()

const profileSchema = z.object({
  name: z.string().min(2, 'Too short'),
  email: z.string().email('Invalid email')
})

type ProfileSchema = z.output<typeof profileSchema>

const profile = reactive<Partial<ProfileSchema>>({
  name: userStore.fullName,
  email: userStore.user.email
})

async function onSubmit(event: FormSubmitEvent<ProfileSchema>) {
  toast.add({
    title: 'Success',
    description: 'Your settings have been updated.',
    icon: 'i-lucide-check',
    color: 'success'
  })
  console.log(event.data)
}
</script>